import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/account.js';
import { sendConsultationEmail } from '../../helper/emailService';

function Register() {
    const history = useHistory();

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [studyPlan, setStudyPlan] = useState('');
    const [prefCountry, setPrefCountry] = useState('');
    const [consent, setConsent] = useState(false);
    const [captchaInput, setCaptchaInput] = useState('');
    
    const [num1, setNum1] = useState(0);
    const [num2, setNum2] = useState(0);
    
    const [errors, setErrors] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [successMsg, setSuccessMsg] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [lastSubmitTime, setLastSubmitTime] = useState(0);

    const generateCaptcha = () => {
        setNum1(Math.floor(Math.random() * 9) + 1);
        setNum2(Math.floor(Math.random() * 9) + 1);
        setCaptchaInput('');
    };

    useEffect(() => {
        generateCaptcha();
    }, []);

    const validateForm = () => {
        const newErrors = {};

        if (!name.trim()) {
            newErrors.name = "Name can't be blank";
        } else if (name.trim().length > 100) {
            newErrors.name = "Name cannot exceed 100 characters";
        }

        if (!email.trim()) {
            newErrors.email = "Email can't be blank";
        } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email.trim())) {
            newErrors.email = "Not a valid email";
        } else if (email.trim().length > 100) {
            newErrors.email = "Email cannot exceed 100 characters";
        }

        if (!phone.trim()) {
            newErrors.phone = "Phone number can't be blank";
        } else if (!/^\d+$/.test(phone.trim())) {
            newErrors.phone = "Phone number must contain digits only";
        } else if (phone.trim().length < 11) {
            newErrors.phone = "Phone number must be at least 11 digits";
        } else if (phone.trim().length > 15) {
            newErrors.phone = "Phone number cannot exceed 15 digits";
        }

        if (!studyPlan) {
            newErrors.studyPlan = "Please select what you plan to study";
        }

        if (!prefCountry) {
            newErrors.prefCountry = "Please select preferred country";
        }

        if (!consent) {
            newErrors.consent = "Consent is required to submit the form";
        }

        const correctAnswer = num1 + num2;
        if (!captchaInput.trim()) {
            newErrors.captcha = "Solving the math check is required";
        } else if (parseInt(captchaInput, 10) !== correctAnswer) {
            newErrors.captcha = "Incorrect answer, please try again";
        }

        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (isSubmitting) return;

        // Rate limiting: 10 second cooldown between requests
        const now = Date.now();
        if (now - lastSubmitTime < 10000) {
            setErrorMsg("Please wait a few seconds before submitting another request.");
            return;
        }

        setSubmitted(true);
        const newErrors = validateForm();

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setSuccessMsg('');
            setErrorMsg('');
            if (newErrors.captcha) {
                generateCaptcha();
            }
            return;
        }

        setErrors({});
        setSuccessMsg('');
        setErrorMsg('');
        setIsSubmitting(true);

        try {
            await sendConsultationEmail({
                name,
                email,
                phone,
                studyPlan,
                prefCountry,
                isRegistration: true
            });
            setSuccessMsg('Your registration request has been submitted successfully! One of our education counselors will get back to you soon. Redirecting to home page...');
            setName('');
            setEmail('');
            setPhone('');
            setStudyPlan('');
            setPrefCountry('');
            setConsent(false);
            setCaptchaInput('');
            setSubmitted(false);
            generateCaptcha();
            setLastSubmitTime(Date.now());

            setTimeout(() => {
                history.push('/');
            }, 3500);
        } catch (err) {
            setErrorMsg('Failed to submit registration request. Please try again later or contact us directly at info@globalabroadbd.com.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Styles>
            {/* Main Wrapper */}
            <div className="main-wrapper registration-page">

                {/* Header 2 */}
                <HeaderTwo />

                {/* Registration Area */}
                <section className="registration-area">
                    <Container>
                        <Row>
                            <Col md="12">
                                <div className="registration-box">
                                    <div className="registration-title text-center">
                                        <h3>Apply For Registration</h3>
                                    </div>
                                    {successMsg && (
                                        <div style={{ color: '#ffffff', backgroundColor: '#28a745', padding: '10px', borderRadius: '5px', marginBottom: '20px', fontWeight: '500', textAlign: 'center' }}>
                                            {successMsg}
                                        </div>
                                    )}
                                    {errorMsg && (
                                        <div style={{ color: '#ffffff', backgroundColor: '#dc3545', padding: '10px', borderRadius: '5px', marginBottom: '20px', fontWeight: '500', textAlign: 'center' }}>
                                            {errorMsg}
                                        </div>
                                    )}
                                    <form onSubmit={handleSubmit} className="form">
                                        <p className={`form-control ${submitted && errors.name ? 'error' : submitted && name ? 'success' : ''}`}>
                                            <label htmlFor="registration_name">Name</label>
                                            <input 
                                                type="text" 
                                                placeholder="Enter your Name" 
                                                id="registration_name"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                                disabled={isSubmitting}
                                            />
                                            <span className="registration_input-msg">{errors.name}</span>
                                        </p>
                                        <p className={`form-control ${submitted && errors.email ? 'error' : submitted && email ? 'success' : ''}`}>
                                            <label htmlFor="registration_email">Email Address</label>
                                            <input 
                                                type="email" 
                                                placeholder="Enter your Email" 
                                                id="registration_email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                disabled={isSubmitting}
                                            />
                                            <span className="registration_input-msg">{errors.email}</span>
                                        </p>
                                        <p className={`form-control ${submitted && errors.phone ? 'error' : submitted && phone ? 'success' : ''}`}>
                                            <label htmlFor="registration_phone">Phone Number</label>
                                            <input 
                                                type="text" 
                                                placeholder="Enter Phone Number" 
                                                id="registration_phone"
                                                value={phone}
                                                onChange={(e) => setPhone(e.target.value)}
                                                disabled={isSubmitting}
                                            />
                                            <span className="registration_input-msg">{errors.phone}</span>
                                        </p>

                                        <p className={`form-control form-control-select ${submitted && errors.studyPlan ? 'error' : submitted && studyPlan ? 'success' : ''}`}>
                                            <label>What do you plan to study?</label>
                                            <select 
                                                value={studyPlan}
                                                onChange={(e) => setStudyPlan(e.target.value)}
                                                className={!studyPlan ? 'placeholder-selected' : ''}
                                                style={{ cursor: 'pointer' }}
                                                disabled={isSubmitting}
                                            >
                                                <option value="">Select option</option>
                                                <option value="Foundation">Foundation</option>
                                                <option value="Associate or Diploma">Associate / Diploma</option>
                                                <option value="High School">High School</option>
                                                <option value="Bachelors">Bachelors</option>
                                                <option value="Masters">Masters</option>
                                                <option value="Research">Research</option>
                                            </select>
                                            <span className="registration_input-msg">{errors.studyPlan}</span>
                                        </p>

                                        <p className={`form-control form-control-select ${submitted && errors.prefCountry ? 'error' : submitted && prefCountry ? 'success' : ''}`}>
                                            <label>Your preferred country?</label>
                                            <select 
                                                value={prefCountry}
                                                onChange={(e) => setPrefCountry(e.target.value)}
                                                className={!prefCountry ? 'placeholder-selected' : ''}
                                                style={{ cursor: 'pointer' }}
                                                disabled={isSubmitting}
                                            >
                                                <option value="">Select country</option>
                                                <option value="Malaysia">Malaysia</option>
                                                <option value="Malta">Malta</option>
                                                <option value="Greece">Greece</option>
                                                <option value="USA">USA</option>
                                                <option value="Cyprus">Cyprus</option>
                                                <option value="Europe">Europe</option>
                                                <option value="Vietnam">Vietnam</option>
                                                <option value="India">India</option>
                                                <option value="Australia">Australia</option>
                                                <option value="Canada">Canada</option>
                                                <option value="Germany">Germany</option>
                                                <option value="UK">UK</option>
                                                <option value="South Korea">South Korea</option>
                                                <option value="Japan">Japan</option>
                                            </select>
                                            <span className="registration_input-msg">{errors.prefCountry}</span>
                                        </p>

                                        <p className="form-control-checkbox">
                                            <input 
                                                type="checkbox" 
                                                id="registration_consent" 
                                                checked={consent}
                                                onChange={(e) => setConsent(e.target.checked)}
                                                disabled={isSubmitting}
                                            />
                                            <label htmlFor="registration_consent">
                                                I consent to receive updates from Global Abroad about study abroad opportunities and agree to the Terms of Use and Privacy Policy.
                                            </label>
                                            {submitted && errors.consent && <span className="error-msg">{errors.consent}</span>}
                                        </p>

                                        <p className={`form-control-captcha ${submitted && errors.captcha ? 'error' : submitted && captchaInput && !errors.captcha ? 'success' : ''}`}>
                                            <label htmlFor="registration_captcha">What is {num1} + {num2} ?</label>
                                            <input 
                                                type="text" 
                                                id="registration_captcha" 
                                                placeholder="Answer"
                                                value={captchaInput}
                                                onChange={(e) => setCaptchaInput(e.target.value)}
                                                disabled={isSubmitting}
                                            />
                                            {submitted && errors.captcha && <span className="error-msg">{errors.captcha}</span>}
                                        </p>

                                        <button type="submit" disabled={isSubmitting}>
                                            {isSubmitting ? "Sending..." : "Submit Request"}
                                        </button>
                                    </form>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>

                {/* Footer 2 */}
                <FooterTwo />

            </div>
        </Styles>
    );
}

export default Register;